import {TkFile} from '../../interfaces/core/tk-file';
import {DeleteFileOptions, Directory, Filesystem} from '@capacitor/filesystem';
import {Platform} from '@ionic/angular';
import {FilesystemService} from './filesystem.service';
import {Capacitor} from '@capacitor/core';
import {Photo} from '@capacitor/camera';
import {TkFileFactory} from '../../factories/core/tk-file-factory';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  constructor(private platform: Platform,
              private filesystemService: FilesystemService) {
  }

  /**
   *
   * @param tkFile
   */
  public async readImage(tkFile: TkFile): Promise<TkFile> {
    if (!this.platform.is('hybrid')) {
      const readFile = await Filesystem.readFile({
        path: tkFile.filepath,
        directory: Directory.Data
      });
      tkFile.webviewPath = `data:image/jpeg;base64,${readFile.data}`;
    }
    return tkFile;
  }

  /**
   *
   * @param tkFile
   * @param blob
   * @param path
   */
  public async updateImage(tkFile: TkFile, blob: Blob, path: string = null): Promise<TkFile> {
    const base64Data = await this.filesystemService.convertBlobToBase64(blob) as string;
    await this.deleteImage(tkFile);
    const fileName = this.filesystemService.generatePath(path) + new Date().getTime() + '.jpeg';
    const writeFileResult = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Data,
      recursive: true
    });

    if (this.platform.is('hybrid')) {
      tkFile.filepath = writeFileResult.uri;
      tkFile.webviewPath = Capacitor.convertFileSrc(writeFileResult.uri);
    } else {
      tkFile.webviewPath = tkFile.filepath = fileName;
    }
    return tkFile;
  }

  /**
   *
   * @param photo
   * @param path
   */
  public async saveImage(photo: Photo, path: string = null): Promise<TkFile> {
    let tkFile = TkFileFactory.fromPhoto(photo);

    const base64Data = await this.filesystemService.readAsBase64(tkFile);
    const fileName = this.filesystemService.generatePath(path) + new Date().getTime() + '.jpeg';

    const savedFile = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Data,
      recursive: true
    });

    tkFile.format = 'jpeg';

    if (this.platform.is('hybrid')) {
      tkFile.filepath = savedFile.uri;
      tkFile.webviewPath = Capacitor.convertFileSrc(savedFile.uri);
    }
    else {
      tkFile.filepath = fileName;
    }
    return tkFile;
  }

  /**
   *
   * @param tkFile
   * @param data
   * @param path
   */
  public async writeImage(
    tkFile: TkFile,
    data: any,
    path: string = null
  ): Promise<TkFile> {
    const fileName = this.filesystemService.generatePath(path) + new Date().getTime() + '.' + tkFile.format;

    const file = await Filesystem.writeFile({
      path: fileName,
      data: data,
      directory: Directory.Data,
      recursive: true
    });

    if(this.platform.is('hybrid')) {
      tkFile.filepath = file.uri;
    } else {
      tkFile.filepath = fileName;
    }

    tkFile.loaded = true;
    return tkFile;
  }

  /**
   *
   * @param tkFile
   */
  public async deleteImage(tkFile: TkFile): Promise<void> {
    if (tkFile.filepath) {
      const deleteFileOptions: DeleteFileOptions = {path: tkFile.filepath};
      if (!this.platform.is('hybrid')) {
        deleteFileOptions.directory = Directory.Data;
      }
      await Filesystem.deleteFile(deleteFileOptions);
    }
  }

}